import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import DateInput from '../input/date'
import EmbededEntityInput from '../input/batch_update_embedded_entity'
import OptionSelect from 'bstrap-react-mobx-admin/new_src/input/option_select'
import SelectInput from '../input/select'
import moment from 'moment'
import { Button } from 'react-bootstrap'

const FPrivateCategoriesUpdateEdit = ({ store, label, items, disabledEntityFromBatch, ...rest }) => {
  const _FPrivateCategoriesUpdateForm = observer(({ record, state, updateFormField, errors }) => {
    const dateRestriction = store.timeRestriction.flyprivateCategories

    const alowedJustValidTo = store.cv.items.some(i => moment(i.valid_from).isBefore(moment(dateRestriction.valid_from.restriction)))
    let validToMindate = alowedJustValidTo ? dateRestriction.valid_to.minDate : dateRestriction.valid_to.minDateToday
    validToMindate = moment(record.get('valid_from')).isBefore(moment(validToMindate)) ? record.get('valid_from') : validToMindate

    const catPlatform = !alowedJustValidTo && store.getCatPlatform(store)
    const catPlatformFilter = !alowedJustValidTo ? store.getCatPlatformFilter(catPlatform) : undefined

    return (
      <div className='row'>
        {store.lastSaved && store.lastSaved.FPVFilmCategory && !record.has('updated') &&
          <div className='col-xs-12'>
            <Button bsStyle='primary' onClick={() => store.onAddClickedCats(store, record, items)}>
              {store.__('+ Load data from the last saved item')}
            </Button><br />&nbsp;
          </div>
        }
        <div className='col-sm-12 col-md-6'>
          {!alowedJustValidTo &&
            <Fragment>
              <OptionSelect
                attr='platformFilter' label={store.__('platform')} value={catPlatform}
                onChange={store.updateStorageField(store)}
                options={store.options.get('FlyPrivatePlatforms')}
                labelattr='text' errors={errors} />
              <SelectInput attr={'enum_value'} label={store.__('category')}
                onChange={updateFormField} record={record} valueFilterFc={catPlatformFilter}
                optionsattr='FlyprivateCategories' optionsrecord={store.options}
                labelattr='text' valueattr='value' errors={errors} />
              <SelectInput
                label={store.__('region')} attr={'regions'}
                labelattr='text' valueattr='value'
                record={record} onChange={updateFormField} errors={errors}
                optionsrecord={store.options} optionsattr='Countries'
                valueFilterFc={store.removeContinents()} />
              <DateInput label={store.__('valid from')} attr={'valid_from'}
                minDate={dateRestriction.valid_from.minDate}
                record={record} onChange={updateFormField} errors={errors} />
            </Fragment>
          }
          <DateInput label={store.__('valid to')} attr={'valid_to'}
            record={record} onChange={updateFormField} errors={errors}
            minDate={validToMindate}
          />
        </div>
        {alowedJustValidTo &&
          <div className='col-sm-12'>
            <div className='alert alert-dismissible alert-warning'>
              <p><strong>{store.__('WARNING').concat(': ')}</strong>
                {store.__('Because of the records with "Valid from" date in the past, only "Valid to" date can be updated.')}
              </p>
            </div>
          </div>
        }
      </div>
    )
  })

  return (
    <EmbededEntityInput
      attr='flyprivateCategoriesUpdate'
      disabled={!!disabledEntityFromBatch}
      label={label}
      store={store}
      EditForm={_FPrivateCategoriesUpdateForm}
      {...rest}
    />
  )
}
export default FPrivateCategoriesUpdateEdit
